import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Modul, ModulUpdate } from './modul.interface';

@Injectable({
    providedIn: 'root'
})
export class ModulService {
    private basePath = environment.interop.basePath;

    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.list;
    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.delete;
    private listActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.listActive;
    private listPublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.listPublic;
    private updateActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.updateActive;
    private updatePublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.modul.updatePublic;

    constructor(private http: HttpClient) { }

    list() {
        return this.http.get(this.listUrl);
    }

    add(modul: Modul) {
        return this.http.post(this.storeUrl, modul);
    }

    update(modul: ModulUpdate) {
        return this.http.put(this.updateUrl, modul);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    listActive() {
        return this.http.get(this.listActiveUrl);
    }

    listPublic() {
        return this.http.get(this.listPublicUrl);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.updateActiveUrl + id, {});
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.updatePublicUrl + id, {});
    }
}
